<div class="icu-alarm-toast" *transloco="let t">
    <div class="icu-alarm-toast__icon">
        <mat-icon class="material-symbols-outlined">notification_important</mat-icon>
    </div>
    <a class="icu-alarm-toast__body" [routerLink]="data.routerLinkUrl" (click)="dismiss()">
        <span class="icu-alarm-toast__title">{{ data.type }}</span>
        <span class="icu-alarm-toast__device">{{ data.deviceId }}</span>
        <span class="icu-alarm-toast__param" *ngIf="data.parameter">{{ data.parameter }}</span>
    </a>
    <button class="icu-alarm-toast__close" type="button" (click)="dismiss()" [attr.aria-label]="t('Close')" [attr.title]="t('Close')">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
</div>
